import React, { useEffect } from 'react';

import { runningInRNWebView, useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

import { useConfig } from '../../defaultConfig';
import useLastLogin from '../../fetchHooks/useLastLogin';
import useTranslation from '../../hooks/useTranslation';
import { formatLastLoginTime } from '../../utils/mapper/formatLastLoginTime';
import useLastShowLogin, { setLastShownLogin } from './useLastShowLogin';

import './LastLogin.scss';

const LastLogin: React.FC = () => {
    const translated = useTranslation();
    const { featureToggles } = useConfig();
    const { supports } = useReactNativeProps();
    const showLastLogin =
        featureToggles.enableLastLogin && (!runningInRNWebView || supports?.showLastLoginToasterInWeb);

    const { data: lastLogin } = useLastLogin(showLastLogin);
    const lastShownLogin = useLastShowLogin();

    useEffect(() => {
        if (lastLogin?.dateTime && lastShownLogin !== lastLogin?.dateTime) {
            setTimeout(() => {
                setLastShownLogin(lastLogin.dateTime);
            }, 0);
        }
    }, [lastLogin?.dateTime, lastShownLogin]);

    if (!showLastLogin || lastShownLogin === lastLogin?.dateTime) {
        return <></>;
    }

    return (
        <div className="last-login-container">
            {lastLogin?.dateTime && (
                <p className="last-login">
                    <span className="last-login__label">{translated.lastLogin}</span>
                    {formatLastLoginTime(lastLogin.dateTime)}
                </p>
            )}
        </div>
    );
};

export default LastLogin;
